import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import _defineProperty from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.assign";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
import { DEFAULTS } from "../../base/helpers/variables";
import { ColumnGroup } from "./column-group";
export var COLUMN_DEFAULTS = {
  sizes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, "one-third", "two-thirds", "one-quarter", "half", "three-quarters", "one-fifth", "two-fifths", "three-fifths", "four-fifths", "full"]
};
export var Column = Object.assign(forwardRefAs(function (_a, ref) {
  var _classNames;

  var className = _a.className,
      mobile = _a.mobile,
      tablet = _a.tablet,
      desktop = _a.desktop,
      widescreen = _a.widescreen,
      fullhd = _a.fullhd,
      touch = _a.touch,
      narrow = _a.narrow,
      offset = _a.offset,
      size = _a.size,
      rest = tslib_1.__rest(_a, ["className", "mobile", "tablet", "desktop", "widescreen", "fullhd", "touch", "narrow", "offset", "size"]);

  var breakpoints = {
    desktop: desktop,
    fullhd: fullhd,
    mobile: mobile,
    tablet: tablet,
    touch: touch,
    widescreen: widescreen
  };
  return React.createElement(Generic, Object.assign({
    className: classNames("column", (_classNames = {}, _defineProperty(_classNames, "is-".concat(size), size !== undefined), _defineProperty(_classNames, "is-offset-".concat(offset), offset !== undefined), _defineProperty(_classNames, "is-narrow", narrow), _classNames), Object.keys(breakpoints).map(function (breakpoint) {
      var _ref;

      var value = breakpoints[breakpoint];
      return value === undefined ? {} : (_ref = {}, _defineProperty(_ref, "is-".concat(value.size, "-").concat(breakpoint), value.size !== undefined), _defineProperty(_ref, "is-narrow-".concat(breakpoint), value.narrow), _defineProperty(_ref, "is-offset-".concat(value.offset, "-").concat(breakpoint), value.offset !== undefined), _ref);
    }).reduce(function (acc, cv) {
      return Object.assign({}, acc, cv);
    }, {}), className),
    ref: ref
  }, rest));
}, {
  as: "div"
}), {
  Group: ColumnGroup
});
Column.displayName = "Column";
var ColumnSizeModifierPropTypes = {
  narrow: PropTypes.bool,
  offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Column.propTypes = Object.assign({}, DEFAULTS.breakpoints.map(function (breakpoint) {
  return _defineProperty({}, breakpoint, PropTypes.shape(ColumnSizeModifierPropTypes));
}).reduce(function (acc, cv) {
  return Object.assign({}, acc, cv);
}, {}), ColumnSizeModifierPropTypes);